<template>
    <div>
        <div class="page-title">
            <h4 v-if='this.products'> {{$t('txt.nivel3')}}: {{this.products.name}}</h4>
        </div>
        <div class="table-header edit-header">
            <div class="search-box" v-if="$can(['update product'])">
                <router-link v-if='this.products' :to="{ name: 'editproduct', params: { id: products.id }}">
                    <button type="button" class="add-user edit-button">
                        <i class="far fa-edit"></i>
                        <span> {{$t('placeholder.editeaza')}} </span>
                    </button>
                </router-link>
            </div>
        </div>
        <form class="add-user-form">
            <div class="row">
                <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="account-detail-box">
                        <ul class="account-detail-list">
                            <li v-for="input_field in input_fields.column_1" :key="input_field.id">
                              <div class="view-info-wrapper">
                                <div class="contact-design">
                                  <i :class="input_field.icon"></i>
                                  <span> {{input_field.labelName}} </span>
                                </div>
                                <p> {{input_field.inputValue}} </p>
                              </div>
                            </li>
                            <li v-if="products" v-for="price in priceCategoryes" :key="price.value">
                              <div class="view-info-wrapper">
                                <div class="contact-design">
                                  <i class="fas fa-tags info-tool"></i>
                                  <span> {{price.display}} </span>
                                </div>
                                <p> {{products.prices[price.name]}} </p>
                              </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="account-detail-box">
                        <ul class="account-detail-list">
                            <li v-for="input_field in input_fields.column_2" :key="input_field.id">
                              <div class="view-info-wrapper">
                                <div class="contact-design">
                                  <i v-bind:class="input_field.icon"></i>
                                  <span> {{input_field.labelName}} </span>
                                </div>
                                <p> {{input_field.inputValue}} </p>
                              </div>
                            </li>
                            <li>
                              <div class="view-info-wrapper">
                                <div class="contact-design">
                                  <i class="fas fa-parachute-box"></i>
                                  <span> {{$t('placeholder.furnizori')}} </span>
                                </div>
                                <p class="product-providers-list">
                                  <span  v-for="provider in this.products.providers" :key="provider.id">
                                    {{provider.company_name}}
                                  </span>
                                </p>
                              </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12" v-if="this.products">
                    <div class="account-detail-box">
                        <ul class="account-detail-list">
                            <li v-for="stock in this.products.stock" :key="stock.id">
                              <div class="view-info-wrapper">
                                <div class="contact-design">
                                  <i class="fas fa-warehouse"></i>
                                  <span> {{stock.warehouse.name}} </span>
                                </div>
                                <p> {{stock.qty}} </p>
                              </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-xl-12 col-md-12 col-12">
                  <div class="template-section-heading">
                      <h4> Fotografii produs </h4>
                  </div>
                  <div class="template-img-wrapper" v-if="products">
                    <viewer :images="url.img">
                      <div class="template-img-preview" v-for="file in products.files" :key="file.id">
                          <img :src="file.link" alt="product-image">
                      </div>
                    </viewer>
                  </div>
                  <div class="template-product-description">
                    <div class="template-section-heading">
                        <h4> Descriere produs </h4>
                    </div>
                    <p> {{description}} </p>
                  </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>

import Level2Service from '../../api-services/nivel2.service.js'
import Level1Service from '../../api-services/nivel1.service.js'
import ProductsService from '../../api-services/products.service.js'

export default {
  name: 'viewsubtype',
  data () {
    return {
      level2: null,
      level1: null,
      products: null,
      level1_selected: null,
      level2_selected: null,
      description: null,
      url: {
        img: []
      },
      priceCategoryes: ProductsService.getPriceCategories()
    }
  },
  methods: {
    getProduct () {
      ProductsService.get(this.$route.params.id)
        .then((response) => {
          this.$store.dispatch('hideLoading')
          this.products = response.data.data
          this.description = response.data.data.description
          this.getCategories()
        })
        .catch((error) => {
          this.$store.dispatch('hideLoading')
          console.log(error)
        })
    },
    getCategories () {
      Level1Service.getAll().then((response) => {
        this.level1 = response.data.data
        this.level1_selected = this.level1.find(county => county.id === this.level1.name)
        this.$store.dispatch('hideLoading')
        this.getSubcategories()
      }).catch((error) => {
        console.log(error)
        this.$store.dispatch('hideLoading')
      })
    },
    getSubcategories () {
      Level2Service.getAll().then((response) => {
        this.level2 = response.data.data
        this.level2_selected = this.level2.find(county => county.id === this.level2.name)
        this.$store.dispatch('hideLoading')
      }).catch((error) => {
        console.log(error)
        this.$store.dispatch('hideLoading')
      })
    },
    getLevel2 () {
      Level2Service.get(this.$route.params.id)
        .then((response) => {
          this.level2 = response.data.data
          this.$store.dispatch('hideLoading')
        })
        .catch((error) => {
          console.log(error)
          this.$store.dispatch('hideLoading')
        })
    }
  },
  computed: {
    input_fields () {
      return {
        column_1: [
          {
            inputName: 'order',
            labelName: this.$t('placeholder.ord'),
            inputValue: (this.products) ? this.products.ord : null,
            icon: 'fas fa-sort-numeric-up'
          },
          {
            inputName: 'nivel1',
            labelName: this.$t('placeholder.categorie'),
            inputValue: (this.products && this.products.nivel1) ? this.products.nivel1.name : null,
            icon: 'fas fa-sitemap'
          },
          {
            inputName: 'nivel2',
            labelName: this.$t('placeholder.subcategorie'),
            inputValue: (this.products && this.products.nivel2) ? this.products.nivel2.name : null,
            icon: 'far fa-dot-circle'
          },
          {
            inputName: 'nivel3',
            labelName: this.$t('placeholder.subtip'),
            inputValue: (this.products && this.products.nivel3) ? this.products.nivel3.name : null,
            icon: 'far fa-dot-circle'
          }
        ],
        column_2: [
          {
            inputName: 'name',
            labelName: this.$t('placeholder.denumire'),
            inputValue: (this.products) ? this.products.name : null,
            icon: 'fas fa-file-signature'
          },
          {
            inputName: 'stoc',
            labelName: this.$t('placeholder.stoc'),
            inputValue: (this.products) ? this.products.stoc : null,
            icon: 'fas fa-file-signature'
          },
          {
            inputName: 'cost_acquisition',
            labelName: this.$t('placeholder.costAchizitie'),
            inputValue: (this.products) ? this.products.cost_acquisition : null,
            icon: 'fas fa-file-signature'
          },
          {
            inputName: 'discount',
            labelName: this.$t('placeholder.discount'),
            inputValue: (this.products) ? this.products.discount : null,
            icon: 'fas fa-money-bill-wave info-tool'
          },
          {
            inputName: 'manufacturer',
            labelName: this.$t('placeholder.manufacturer'),
            inputValue: (this.products) ? ((this.products.manufacturer) ? this.products.manufacturer.name : null) : null,
            icon: 'fas fa-dolly-flatbed'
          }
        ]
      }
    }
  },
  mounted () {
    this.getProduct()
  }
}
</script>
